var ArrayHelper = /** @class */ (function () {
    function ArrayHelper() {
    }
    ArrayHelper.ArrayOf = function (dataArray, parserFunc) {
        var res = [];
        var currentInstance;
        if (!dataArray.length) {
            return res;
        }
        for (var i = 0; i < dataArray.length; i += 1) {
            currentInstance = parserFunc(dataArray[i]);
            res.push(currentInstance);
        }
        return res;
    };
    return ArrayHelper;
}());
export { ArrayHelper };
//# sourceMappingURL=ArrayHelper.js.map